import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-CM06XYR11X';

// Debug mode for localhost testing
const isDebugMode = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Load Google Analytics script
    const loadGA = () => {
      if (typeof window !== 'undefined' && window.gtag) {
        return; // GA already loaded
      }
      
      // Create script element
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      document.head.appendChild(script);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_title: document.title,
        page_location: window.location.href,
        debug_mode: isDebugMode,
      });
    };

    // Load GA if not already loaded
    if (typeof window !== 'undefined') {
      loadGA();
    }
  }, []);

  useEffect(() => {
    // Track page views
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics; 